import { initialState } from '../initial';
import { actionTypes } from '../actions';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return { ...state, actionProcessing: action.payload };

    case actionTypes.GET_CURRENT_GIFTS:
      return { ...state, currentGifts: action.payload };

    case actionTypes.CURRENT_GIFTS_UPDATE_TRIGGER:
      return { ...state, currentGiftsUpdateTrigger: {} };

    default:
      return state;
  }
}
